import React from 'react';
import styled from 'styled-components';
import { StepConnector as MuiStepConnector, StepIconProps, Stepper, fade } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import { Typography, TypographyProps } from '../../../../../ui-kit';
import { getLabelOffset } from './utils';

export const CheckIcon = styled(Check)`
    font-size: 6px;
    color: #fff;
`;

export const StyledStepper = styled(Stepper)`
    &.MuiStepper-root {
        padding: 32px 0;
        width: 150%;
        margin: 0 -25% 16px;
    }
    .MuiStep-completed + .MuiStep-alternativeLabel + .MuiStep-alternativeLabel {
        .MuiStepConnector-alternativeLabel {
            left: calc(-50% + 8px);
        }
    }
`;

export const StepConnector = styled(MuiStepConnector)`
    .MuiStepConnector-line {
        ${({ theme }) => `
            border-color: ${fade(theme.palette.success.main, 0.16)};
        `}
    }
    .MuiStepConnector-lineHorizontal {
        border-top-width: 2px;
    }

    &.MuiStepConnector-alternativeLabel {
        top: 8px;
        transform: translateY(-50%);
        right: calc(50% + 6px);
        left: calc(-50% + 6px);
    }

    &.MuiStepConnector-active {
        right: calc(50% + 8px);
        left: calc(-50% + 8px);
    }

    &.Mui-disabled {
        right: calc(50% + 6px);
    }
`;

export const StepIconContainer = styled.div<Pick<StepIconProps, 'completed' | 'active'>>`
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    ${({ theme }) => `
        width: ${theme.spacing(2)}px;
        height: ${theme.spacing(2)}px;
        :before {
            content: '';
            display: block;
            position: absolute;
            background-color: ${fade(theme.palette.success.main, 0.16)};
            width: ${theme.spacing(1.5)}px;
            height: ${theme.spacing(1.5)}px;
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    `}
    ${({ active, theme }) => active &&
        `
            background-color: ${fade(theme.palette.success.main, 0.16)};
            :before {
                width: ${theme.spacing(0.75)}px;
                height: ${theme.spacing(0.75)}px;
                background-color: ${theme.palette.success.main};
            }
        `}
    ${({ theme, completed }) => completed &&
        `
            background-color: ${theme.palette.success.main};
        `}
`;

interface AbsolutelyPositionedTypographyProps extends TypographyProps {
    isTop?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
}

export const AbsolutelyPositionedTypography = styled(
    ({ isTop, isFirst, isLast, ...props }: AbsolutelyPositionedTypographyProps) => <Typography {...props} />
)`
    position: absolute;
    width: max-content;
    ${({ isFirst, isLast }) => (!isFirst && !isLast) && `
        left: 50%;
        transform: translateX(-50%);
    `}
    ${({ isLast }) => isLast &&`
        right: 0;
    `}
    ${({ isFirst }) => isFirst &&`
        left: 0;
    `}
    ${({ isTop, theme, variant }) => `
        ${isTop
        ? `top: ${getLabelOffset(variant, theme)}`
        : `bottom: ${getLabelOffset(variant, theme)}`};
    `}
`;
